import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import {
  getChords,
  getContentImage,
  getContentText,
  getContentTitle,
  getLessonsMessage,
  getLevelDisplay,
  getTitle,
} from './CurriculumContent';
import Link from '../Link';

function getRowContent(items, rowInfo, isSearch) {
  const { display, height, itemHeightStyle } = rowInfo;
  return items.map(item => (
    <Link
      className="black"
      data-id={`curriculum-row-${item.title}`}
      key={uuid()}
      to={item.url}
      trackEvent={item.trackEvent || null}
    >
      <div className={`f6 mid-gray db w-100 source-sans ttc ${itemHeightStyle}`}>
        {getContentTitle(item.title, isSearch)}
      </div>
      <div className="flex mid-gray justify-between items-start tl pb2">
        {getChords(display.chords, item.chords, `db tl w-60 ${itemHeightStyle}`, 'pr1')}
        {getContentText(display.type, item.type, `${itemHeightStyle} ttc`)}
        {getContentText(display.description, item.description, `${itemHeightStyle} source-sans`)}
        {getContentText(display.lessons, getLessonsMessage(item.lessons), itemHeightStyle)}
        {getContentText(
          display.minutes && item.minutes,
          `${item.minutes} minutes`,
          `gray ${itemHeightStyle}`,
        )}
        {getLevelDisplay(display.level, item.level, `${height} flex items-start`)}
      </div>
    </Link>
  ));
}

function getRenderedItems(content, display, styleObj) {
  const { height } = styleObj;
  const itemHeightStyle = `${height} flex items-start`;

  return content.map(rowContent => {
    const { title, url, trackEvent, isSearch, items } = rowContent;

    return (
      <div className="flex items-center pv2" key={`curriculum-large-${url}`}>
        <div className="flex w-100">
          {getContentImage(rowContent, styleObj)}
          <div className="flex-auto items-start">
            {getTitle({ title, url, trackEvent, itemHeightStyle, isSearch })}
            <div className="w-100 f7">
              {getRowContent(items, { display, height, itemHeightStyle }, isSearch)}
            </div>
          </div>
        </div>
      </div>
    );
  });
}

const CurriculumSmall = ({ content, display, styleObj }) => {
  const renderedItems = getRenderedItems(content, display, styleObj);
  return <div>{renderedItems}</div>;
};

CurriculumSmall.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({})),
  display: PropTypes.shape({}),
  styleObj: PropTypes.shape({}),
};

CurriculumSmall.defaultProps = {
  content: [],
  display: {},
  styleObj: {},
};
export default CurriculumSmall;
